import { PlansTabBillingOptionsValues } from './components/plans-tab/types';

export enum SerializedBillingCycle {
  Monthly = 'month',
  Annual = 'year',
}

export interface SerializedPlanPrice {
  billingCycle: SerializedBillingCycle;
  amountCents: number;
}

export interface SerializedPlan {
  id: string;
  name: string;
  isActive: boolean;
  isMostPopular: boolean;
  callForPricingEnabled: boolean;
  prices: SerializedPlanPrice[];
  sortOrder: number;
}

export interface SerializedPlansConfig {
  billingOptions: PlansTabBillingOptionsValues;
  plans: SerializedPlan[];
}
export enum TabValues {
  Plans = 0,
  Style = 1,
}
